module.exports = __webpack_public_path__ + "5e06da0b6750a5c0003b4dcafb2b577c.fbx";